import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from 'src/app/common/services/auth/auth.service';
import { OrganizationService } from 'src/app/common/services/organization/organization.service';
import { ProjectConstants } from 'src/assets/constants/project.constants';

@Injectable({
  providedIn: 'root'
})
export class OrganizationGuard implements CanActivate {
  constructor(
    private router: Router,
    private organizationService: OrganizationService,
    private authService: AuthService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const isLoggedIn = this.authService.isLoggedIn();
    if (isLoggedIn) {
      try {
        const hasOrganization =
          await this.organizationService.checkIfUserHasCurrentOrganization();
        if (hasOrganization) {
          return true;
        } else {
          this.router.navigateByUrl(ProjectConstants.organizationRedirectURL);
          return false;
        }
      } catch (error) {
        // Check how to redirect to a custom error message page
        this.router.navigateByUrl(ProjectConstants.organizationRedirectURL);
        return false;
      }
    }
    return false;
  }
}
